/*
* author: liujianhong
*/
import { ajax } from '@/utils/request';

const api = {
    /**
     ***************** 菜单相关接口  *****************
    */
    // 获取菜单数据
    getMenus() {
        return ajax({
            method: 'get',
            url: `menu-mgt/menus`,
        })
    },
    // 新增菜单
    appendMenu(data: any) {
        return ajax({
            method: 'post',
            url: `menu-mgt/menu`,
            data
        })
    },
    // 修改
    modifyMenu(data: any,id: string|number) {
        return ajax({
            method: 'put',
            url: `menu-mgt/menus/${id}`,
            data
        })
    },
    // 移除菜单
    removeMenu(menuCode: string | number) {
        return ajax({
            method: 'delete',
            url: `menu-mgt/menus/${menuCode}`,
        })
    },
    /**
     ***************** 数据管理相关接口  *****************
    */
    // 数据类型列表查询
    getDatatTypeMgt(data: any) {
        return ajax({
            method: 'get',
            url: `dict-data-mgt/datas?typeCode=${data}`,
        })
    },
    // 数据类型列表
    getDatatTypeList(data: any) {
        return ajax({
            method: 'get',
            url: `dict-type-mgt/types`,
            data
        })
    },
    // 查询 数据类型明细
    getDatatTypeMgtDetail(typeCode: any,dataLabel: any) {
        return ajax({
            method: 'get',
            url: `dict-data-mgt/datas/${typeCode}?dataLabel=${dataLabel}`
        })
    },
    // 新增 数据类型明细
    addDatatTypeMgtDetail(data: any) {
        return ajax({
            method: 'post',
            url: "dictionary-mgt/data",
            data
        })
    },
    // 移除 数据类型明细
    deleteDataTypeDetail(data: any) {
        return ajax({
            method: 'delete',
            url: `dict-data-mgt/datas/${data.id}`,
        })
    },
    // 修改 数据类型明细
    editDatatTypeMgtDetail(id: any,data: any) {
        return ajax({
            method: 'put',
            url: `dict-data-mgt/datas/${id}`,
            data
        })
    },
    // 启用数据类型
    setEnabled(data: any) {
        return ajax({
            method: 'put',
            url: `dict-data-mgt/datas/${data.id}/enabled`
        })
    },
    // 禁用数据类型
    setDisable(data: any) {
        return ajax({
            method: 'put',
            url: `dict-data-mgt/datas/${data.id}/disabled`
        })
    },
    /**
     ***************** 部门信息相关接口  *****************
    */

    // 获取部门相关信息
    getDepts() {
        return ajax({
            method: 'get',
            url: "dept-mgt/depts"
        })
    },
    // 添加
    appendDepts(data: any) {
        return ajax({
            method: 'post',
            url: "dept-mgt/depts",
            data
        })
    },
    // 修改部门信息
    modifyDepts(id: any, data: any) {
        return ajax({
            method: 'put',
            url: `dept-mgt/depts/${id}`,
            data
        })
    },
    // 移除部门信息
    deleteDepts(deptCode: any) {
        return ajax({
            method: 'delete',
            url: `dept-mgt/depts/${deptCode}`,
        })
    },
    /**
    ***************** 角色相关接口  *****************
    */
    // 查询角色
    getRoles() {
        return ajax({
            method: 'get',
            url: `role-mgt/roles/enabled`,
        })
    },
    // 新增角色
    appendRoles(data: any) {
        return ajax({
            method: 'post',
            url: `role-mgt/role`,
            data
        })
    },
    // 移除角色
    deleteRoles(roleCode: any) {
        return ajax({
            method: 'delete',
            url: `role-mgt/roles/${roleCode}`,
        })
    },
    // 修改角色
    modifyRoles(id: any, data: any) {
        return ajax({
            method: 'post',
            url: `role-mgt/roles/${id}`,
            data
        })
    },
    // 获取角色拥有的授权用户列表
    getAuthRole(roleCode: any) {
        return ajax({
            method: 'get',
            url: `user-role-mgt/auth-role/${roleCode}`,
        })
    },
    // 获取权限范围
    getRoleResources(roleCode: any) {
        return ajax({
            method: 'get',
            url: `role-mgt/data-permission/${roleCode}`,
        })
    },
    // 授权
    setAuthorize(data: any) {
        return ajax({
            method: 'post',
            url: `role-mgt/data-permission`,
            data
        })
    },
    // 启用角色
    enabledRole(roleCode: any) {
        return ajax({
            method: 'put',
            url: `role-mgt/roles/${roleCode}/enabled`
        })
    },
    // 禁用角色
    disabledRole(roleCode: any) {
        return ajax({
            method: 'put',
            url: `role-mgt/roles/${roleCode}/disabled`
        })
    },
    /**
     ***************** 员工管理相关接口  *****************
    */
    //  员工树
    getStaffTree(data: any) {
        return ajax({
            method: 'post',
            url: "sys-employee-mgt/employees/tree",
            data
        })
    },
    // 员工分页查询
    getEmployees(data: any) {
        return ajax({
            method: 'get',
            url: "sys-employee-mgt/employees",
            data
        })
    },
    // 新增员工
    appendEmployee(data: any) {
        return ajax({
            method: 'post',
            url: "sys-employee-mgt/employee",
            data
        })
    },
    // 查询员工信息
    getEmployeesInfo(id: any) {
        return ajax({
            method: 'get',
            url: `sys-employee-mgt/employees/${id}`,
        })
    },
    // 导出员工
    exportEmployeesList(data: any){
        return ajax({
            method: 'get',
            url: "sys-employee-mgt/export",
            data,
            type: 'blob'
        })
    },
    // 员工禁用接口
    disableEmployees(id: any) {
        return ajax({
            method: 'put',
            url: `sys-employee-mgt/employees/${id}/disable`,
        })
    },
    // 员工启用接口
    enabledEmployees(id: any) {
        return ajax({
            method: 'put',
            url: `sys-employee-mgt/employees/${id}/enabled`,
        })
    },
    // 修改员工接口 
    setEmployees(id: any,data: any) {
        return ajax({
            method: 'put',
            url: `sys-employee-mgt/employees/${id}`,
            data
        })
    },
    //获取当前登录员工资料
    loginUserInfo(){
        return ajax({
            method: 'get',
            url: `sys-employee-mgt/employees/info`,
        })
    },
    // 修改当前员工资料 
    modifyInfo(data: any) {
        return ajax({
            method: 'put',
            url: `sys-employee-mgt/employees/modify-info`,
            data
        })
    },
    // 功能权限
    getRoleMenu(roleCode: any) {
        return ajax({
            method: 'get',
            url: `role-menu-mgt/role-auth-menu/${roleCode}`,
        })
    },
    // 设置功能权限
    setRoleMenu(data: any) {
        return ajax({
            method: 'post',
            url: `role-menu-mgt/role-auth-menu`,
            data
        })
    },
    // 重置密码
    resetPassword(id: any) {
        return ajax({
            method: 'put',
            url: `sys-employee-mgt/employees/reset-password/${id}`,
        })
    },
    /**
     ***************** 企业信息相关接口  *****************
     */
    
    // 获取企业信息
    getEntInfo(data: any) {
        return ajax({
            method: 'get',
            url: "tenant-mgt/tenant",
            data
        })
    },
    
    // 新增企业信息
    addEntInfo(data: any) {
        return ajax({
            method: 'post',
            url: "tenant-mgt/tenant",
            data
        })
    },
    
    // 修改企业信息
    modifyEntInfo(data: any) {
        return ajax({
            method: 'put',
            url: "tenant-mgt/tenant",
            data
        })
    },
    /**
     ***************** 账号管理相关接口  *****************
    */

    // 获取用户名接口
    getUserName(userCode: any) {
        return ajax({
            method: 'get',
            url: `user-mgt/client/users/${userCode}`
        })
    },

    // 修改用户名密码接口
    modifyPassword(data: any) {
        return ajax({
            method: 'put',
            url: `user-mgt/client/users/modify-password`,
            data
        })
    },
    /**
     ***************** 设备管理相关接口  *****************
    */
    //设备管理分页
    getDeviceList(query: any){
        return ajax({
            method: 'get',
            url: `device-mgt/devices`,
            data: query
        })
    },
    //绑定项目
    deviceBindProject(deviceId: any,projectCode: any){
        return ajax({
            method: 'get',
            url: `device-mgt/${deviceId}/binding/${projectCode}`,
        })
    },
    //解绑项目
    deviceUnBindProject(deviceId: any){
        return ajax({
            method: 'get',
            url: `device-mgt/${deviceId}/unbinding`,
        })
    },
    //启用设备
    enableDevice(deviceId: any){
        return ajax({
            method: 'get',
            url: `device-mgt/${deviceId}/enabled`,
        })
    },
    //停用设备
    disableDevice(deviceId: any){
        return ajax({
            method: 'get',
            url: `device-mgt/${deviceId}/disabled`,
        })
    },

    /**
    ***************** 资料管理分类  *****************
    */
    //资料分类排序
    dataCategoryTreeOrder(data:any){
        return ajax({
            method: 'put',
            url: `data-plan-category-mgt/category/order`,
            data,
        })
    },
    //资料分类树
    dataCategoryTree(){
        return ajax({
            method: 'get',
            url: `data-plan-category-mgt/category`,
        })
    },
    //新增资料分类
    addDataCategory(data:any){
        return ajax({
            method: 'post',
            url: `data-plan-category-mgt/category`,
            data: data
        })
    },
    //编辑资料分类
    editDataCategory(id:any, data:any){
        return ajax({
            method: 'put',
            url: `data-plan-category-mgt/category/${id}`,
            data: data
        })
    },
    //删除资料分类
    deleDataCategory(id:any){
        return ajax({
            method: 'delete',
            url: `data-plan-category-mgt/category/${id}`,
        })
    },


};

export default api;